import { LengthCounterTable } from '@/Emulator/Hardware/APU/LengthCounterTable';

export class TriangleChannel implements ISerializable
{
    private static readonly SEQUENCE: number[] = [
        15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0,
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ];

    public lengthCounter: number = 0;

    private isEnabled: boolean           = false;
    private lengthCounterHalt: boolean   = false;
    private linearCounterLoad: number    = 0;
    private timerPeriod: number          = 0;
    private timerValue: number           = 0;
    private sequenceIndex: number        = 0;
    private linearCounter: number        = 0;
    private linearCounterReload: boolean = false;

    public writeRegister(address: number, value: number): void
    {
        switch (address) {
            case 0x4008:
                // $4008: Linear counter setup
                this.lengthCounterHalt = ((value >> 7) & 1) === 1;
                this.linearCounterLoad = value & 0x7F;
                break;
            case 0x400A:
                // $400A: Timer (low 8 bits)
                this.timerPeriod = (this.timerPeriod & 0x0700) | value;
                break;
            case 0x400B:
                // $400B: Timer (high 3 bits) and Length Counter load
                this.timerPeriod = (this.timerPeriod & 0x00FF) | ((value & 0x07) << 8);

                if (this.isEnabled) {
                    this.lengthCounter = LengthCounterTable[(value >> 3) & 0x1F];
                }

                this.linearCounterReload = true;
                break;
        }
    }

    public setEnabled(enabled: boolean): void
    {
        this.isEnabled = enabled;
        if (!enabled) {
            this.lengthCounter = 0;
        }
    }

    /**
     * Ticks at the exact CPU clock rate (every 1 cycle)
     */
    public tickTimer(): void
    {
        if (this.timerValue > 0) {
            this.timerValue--;
        } else {
            this.timerValue = this.timerPeriod;

            // The sequencer only advances if BOTH counters are > 0
            if (this.lengthCounter > 0 && this.linearCounter > 0) {
                // If the period is incredibly low, the wave becomes ultrasonic.
                // The NES hardware filters this out to prevent popping.
                if (this.timerPeriod > 2) {
                    this.sequenceIndex = (this.sequenceIndex + 1) % 32;
                }
            }
        }
    }

    /**
     * Ticks on the APU Quarter Frame (approx 240Hz/192Hz)
     */
    public clockLinearCounter(): void
    {
        if (this.linearCounterReload) {
            this.linearCounter = this.linearCounterLoad;
        } else if (this.linearCounter > 0) {
            this.linearCounter--;
        }

        if (!this.lengthCounterHalt) {
            this.linearCounterReload = false;
        }
    }

    /**
     * Ticks on the APU Half Frame (approx 120Hz/96Hz)
     */
    public clockLength(): void
    {
        if (!this.lengthCounterHalt && this.lengthCounter > 0) {
            this.lengthCounter--;
        }
    }

    /**
     * Returns the current audio sample (0 to 15)
     */
    public get output(): number
    {
        // if (!this.isEnabled || this.lengthCounter === 0 || this.linearCounter === 0) {
        //     return 0;
        // }

        return TriangleChannel.SEQUENCE[this.sequenceIndex];
    }

    /**
     * @inheritDoc
     */
    public serialize(): Record<string, any>
    {
        return {
            isEnabled:           this.isEnabled,
            lengthCounterHalt:   this.lengthCounterHalt,
            linearCounterLoad:   this.linearCounterLoad,
            timerPeriod:         this.timerPeriod,
            timerValue:          this.timerValue,
            sequenceIndex:       this.sequenceIndex,
            lengthCounter:       this.lengthCounter,
            linearCounter:       this.linearCounter,
            linearCounterReload: this.linearCounterReload,
        };
    }

    /**
     * @inheritDoc
     */
    public deserialize(data: Record<string, any>): void
    {
        this.isEnabled           = data.isEnabled;
        this.lengthCounterHalt   = data.lengthCounterHalt;
        this.linearCounterLoad   = data.linearCounterLoad;
        this.timerPeriod         = data.timerPeriod;
        this.timerValue          = data.timerValue;
        this.sequenceIndex       = data.sequenceIndex;
        this.lengthCounter       = data.lengthCounter;
        this.linearCounter       = data.linearCounter;
        this.linearCounterReload = data.linearCounterReload;
    }
}
